import ClassListPage from "@modules/course-list/ClassListPage"
import CourseListRepo from "@api/server-side/course-list.repo"

export async function getServerSideProps(ctx: any) {
  const course = new CourseListRepo()

  try {
    const res = course.getRawCategories()
    const res2 = course.getRawCourses(ctx.query)

    let categoryList = []
    let classList: any

    const [cat, cls] = await Promise.allSettled([res, res2])

    if (cat.status === "fulfilled" && cat.value) {
      categoryList = JSON.parse(cat.value.body as any).result
    }

    if (cls.status === "fulfilled" && cls.value) {
      classList = JSON.parse(cls.value.body as any).result
    }

    return {
      props: {
        categoryList,
        classList,
        categoryName: "Semua Kelas",
      },
    }
  } catch (e) {
    console.log({ e })

    return {
      props: {
        categoryList: [],
        classList: {},
        categoryName: "",
      },
    }
  }
}

export default ClassListPage
